// userServices.js
// All user related database operations can be defined here.

import { SYSTEM_ERROR } from "../config/CONSTANTS";
import axios from "axios"; // kept for noAuthAccessRequest and getRitmDetail only
import {
  CREATE_ROSTER,
  GET_UNASSIGNED_TRAINEE,
  VIEW_TRAINEE_DETAILS,
  DELETE_IDM_AND_FAC_TICKET,
  INSERT_IDM_TICKET,
  INSERT_FACILITIES_TICKET,
  TECH_EQUIPMENT_SOLUTION,
  FINGER_PRINTING,
  ADJUDICATION,
  LANGUAGE,
  DELETE_FILE_ATTACHMENT,
  GET_ORACLEIDSPII,
  GET_ORACLEIDSPIIBY_FACILITIESTICKETNUMBER,
  GET_ORACLEIDS,
  GET_IDM_DETAILS,
  UPDATE_ROSTER_CONFIG,
  GET_ROSTER_CONFIG,
  GET_ROSTER_CONFIG_BY_ID,
  OVERRIDE_GET_TTD,
  GET_ROSTER_ID,
  GET_PROJECT_DETAILS,
  GET_PRODUCT_TRAINING,
  SAVE_TTD,
  CREATE_CLASS_REQUEST,
  UPDATE_CLASS_REQUEST,
  GET_SITE_LOC,
  GET_PARENT_CLIENT_LIST,
  GET_REASON_DETAILS,
  GET_ATTENDANCE_NA,
  GET_CLASS_REQUEST,
  GET_PARENT_CLIENT,
  SEARCH_CLASS_REQUET_DETAILS,
  GET_ALL_ROSTER_STATUS,
  GET_CLASS_ROSTER_WITH_STATUS,
  GET_CLASS_ROSTER_DETAILS_WITH_REQUEST_ROSTER_ID,
  GET_ASTT_HOME_ASSIGNED_ROSTERS,
  GET_TRAINEE_DETAILS_BY_ROSTER_ID,
  REACTIVATE_CLASS_TRAINEE,
  GET_REQUISITION_LIST,
  GET_REQUISITION_DETAILS,
  GET_ROSTER_DETAILS_BY_REQUISITION_ID,
  GET_PARENT_CLIENT_DETAILS,
  GET_ALL_USERS,
  GET_USER_DETAILS,
  GET_ROSTER_DETAILS,
  GET_AGENT_TRACKER_SEARCH,
  GET_TRAINEE_STATUS,
  GET_PARENT_CLIENT_SEARCH,
  GET_SEARCH_VALUE,
  GET_STATUS_DISPOSITION,
  VIEW_ASSIGNED_TRAINEE,
  GET_WAVE,
  POST_RESCHEDULE,
  DELETE_ROSTER,
  DISTRIBUTION_TYPE,
  BULK_ATTENDANCE,
  BULK_STATUSDISPOSITION,
  SEARCH_TRAINEE,
  SEARCH_CLASS_TRAINEE_BY_SEARCH_TYPE,
  BULK_SAVESTATUSDISPOSITION,
  GET_TTF,
  BULK_EMPLOYEE_TICKET,
  SAVE_TTF,
  NETWORK_TYPE,
  SAVE_EMPLOYEE_TICKET,
  UPDATE_STATUS_DISPOSITION,
  SAVE_ATTENDANCE,
  GET_INFORMATIC_CLIENT,
  GET_TPC,
  SAVE_TPC,
  GET_ACC_DATA,
  SAVE_PRODUCT_TRAINING,
  SAVE_ACC,
  BULK_EMPLOYEE_EQUIPMENT,
  BULK_SAVE_EMPLOYEE_EQUIPMENT,
  BULK_GET_CLASS,
  BULK_POST_CLASS,
  OVERRIDE_GET_EMPLOYEE,
  OVERRIDE_GET_MILESTONE,
  SAVE_EMPLOYEES,
  SAVE_MILESTONES,
  OVERRIDE_GET_TCI,
  SAVE_TCI,
  SAVE_TRAINEE_ROSTER,
  GET_TRAINEE_ROSTER,
  GET_FILE_ATTACHMENT,
  SAVE_FILE_ATTACHMENT,
  SAVE_RESCHEDULE_TRANSFER,
  ROSTER_HISTORY,
  GET_ROSTER_IDM_TRAINEES_DETAIL,
  GET_IDM_SITE_LOCATION,
  ROSTER_LOCK,
  FILE_ATTACHMENT_DETAILS,
  GET_IDM_CLIENT_PROGRAM,
  GET_IDM_EMPLOYEE_LIST,
  GET_IDM_USER_DETAILBYID,
  GET_TALEO_REQ_IDS,
  GET_IDM_TECH_DEP_TYPE_LIST,
  IDM_CREATE_ORDER_REQUEST,
  GET_IDM_RITM_DETAIL,
  SAVE_ATTACHMENT_RITM,
  SAVE_ATTACHMENT_FACILITIES,
  SAVE_ATTACHMENT_RITM_CLIENT,
  SAVE_ATTACHMENT_RITM_CAPCLIENT,
  GET_ROSTER_ID_LIST,
  GET_PII_DATA,
  SAVE_RITM_COMMENT,
  GET_PII_DATA_BY_ORACLEID,
  GET_OVERIDE_ELA,
  GET_OBT_MANAGEMENT_INFO,
  GET_OBT_MANAGEMENT_INFO_BY_ID,
  SAVE_OBT_INFO,
  REFRESH_TRACKING_STATUS,
  GET_IDM_TICKET_DETAILS,
  GET_INFORMATICA_EMPLOYEE_DATA,
  GET_CURRENT_EQUIPMENT_SETUP,
  GET_ALL_CLASSREQIDs,
  GET_ROSTER_TRAINEES_BY_CLASSREQIDs,
  SAVE_ASSIGN_TRAINEES,
  GET_AGENT_COMMENTS_BYROSTERID,
  GET_NEW_CLIENT_PROGRAM,
  SAVE_ROSTERREQUISITION,
  REMOVE_ROSTER_REQUISITION_MAP,
  GET_ROSTERMILESTONE_SEARCHRESULTS,
  GET_TRAINEEMILESTONE_ASSOCIATE,
  DELETE_MILESTONE_ASSOCIATE,
  GET_ALL_MILESTONES,
  SAVE_CLASSROSTERMILESTONES,
  SAVE_MILESTONEEDIT,
  CREATE_MILESTONE,
  GET_ALL_MILESTONES_WITH_STATUSES,
  SAVE_MILESTONESTATUSEDIT,
  CREATE_MILESTONESTATUS,
  GET_MILESTONE_DATATYPE,
  GET_MILESTONE_WITH_LIST_TYPE,
  GET_BULK_MILESTONE_COUNT,
  INSERT_BULK_MILESTONE,
  SAVE_OBT_EMAIL_DETAILS,
  GET_ASKNOW_BS_TASK_DETAILS,
  SAVE_ASKNOW_BS_TASK_DETAILS,
  GET_TRAINEE_ITAM_STATUS_BY_ROSTERID,
  REFRESH_ITAMSTATUS,
  SEARCH_EMPLOYEE_PROFILE,
  SEARCH_CLASS_TRAINEE_PROFILE,
  SAVE_ROSTER_CONFIG_DETAILS,
  SAVE_ROSTER_MANAGEMENT_FIELDS,
  UPLOAD_AGENT_SCHEDULE_DOC_LIB,
  GET_CONFIRM_AGENT_SCHEDULE_BY_ROSTER,
  GET_TRAINEE_PRODUCTION_SCHEDULE,
  GET_ROSTERCONFIGDETAILS_FOR_ASSIGNTRAINEE,
  GET_IDMROSTER_LIST,
  GET_IDMROSTER_DETAILS,
  GET_IDMSYSTEM_IMPACTED,
  GET_IDMSWITCH_TYPE,
  GET_IDM_SANITY_CHECKNOTES,
  GET_IDM_ISSUE_DESCRIPTION,
  CREATE_IDMCREDENTIALTRACKING,
  GET_IDM_CREDENTIALS_BY_PRODUCTTRAINING_MONTH,
  IDMCREDENTIALTRACKING_LOCK,
  GET_EMPLOYEE_ADSTATUS_BY_ORACLEID,
  GET_TRAINEE_DETAILS_FOR_IDMTICKET_BY_ROSTERID,
  GET_IDMCREDENTIAL_BY_TRACKINGID,
  GET_IDMCREDENTIAL_ROSTER_DETAILS_BY_TRACKINGID,
  UPDATE_IDMCREDENTIALTRACKING,
  ACCESS_REQUEST,
  GET_CONFIGURATION_VALUES,
  GET_RELEASEUPDATES,
  CREATE_RELEASEUPDATE,
  UPDATE_RELEASEUPDATE,
  DELETE_RELEASEUPDATE,
  CREATE_IDMEMAILQUEQE,
  GET_ALLCLIENTS,
  GET_OBTMANAGEMENTINFO_BY_PROJECTCODE,
  GET_PROJECTS_BY_CLIENTCODE,
  CREATE_FACILITIES_REQUEST,
  NOAUTH_ACCESS_REQUEST,
  GET_RITM_DETAILS,
  DELETE_IDMCREDENTIALTRACKING,
  GET_AIPROMPT_RESPONSE,
  UPDATE_DATANITIV_CLASS_LIB,
  GET_ALL_PARENTCLIENTS,
  GET_ALL_PROJECTS_BY_PARENTCLIENTCODE,
  GET_WAVE_BY_PROJECTCODE,
  GET_CLASSROSTERS,
  GET_CLASS_SEARCHRESULTS,
  GET_ALL_TECHSOLUTIONS,
  GET_BULK_REBUILD_BY_TECHSOLUTIONID,
  GET_ALL_TASKTYPES,
  GET_ALL_STATUS,
  GET_OMT_CLASSDETAILS_HISTORY,
  SAVE_OMT_CLASSDETAILS,
  DELETE_OMT_CLASSSCHEDULE,
  RESCHEDULE_DELETED_OMT_CLASSSCHEDULE,
  GET_CLASSROSTERS_FORASDLEAD,
  GET_CLASSROSTERS_TASKTYPE,
  GET_CLASSROSTERS_SCHEDULETYPE,
  GET_OMT_ATTENDANCE,
  BULK_POST_OMT_ATTENDANCE,
  UPDATE_MILESTONEREORDER,
  GET_OMT_HARDWARE_STATUSES,
  SAVE_OMT_HARDWARE,
  GET_OMT_HARDWARE,
  GET_OMT_CREDENTIALS,
  BULK_POST_OMT_CREDENTIALS,
  GET_OMT_NETWORK,
  BULK_POST_OMT_NETWORK,
  GET_OMT_OPERATINGSYSTEM,
  BULK_POST_OMT_OPERATINGSYSTEM,
  SAVE_OMT_ATTACHMENT,
  GET_OMT_ATTACHMENT,
  DELETE_OMT_ATTACHMENT,
  GET_OMT_CLASSDETAILSFLAGS,
  GET_OMT_APPLICATION,
  BULK_POST_OMT_APPLICATION,
  JIRA_FEATURE_REQUEST,
  GET_CORE_RATIO_MAPPING,
  CREATE_CORE_RATIO_MAPPING,
  UPDATE_CORE_RATIO_MAPPING,
  DELETE_CORE_RATIO_MAPPING,
  BULK_UPDATE_CORE_RATIO_MAPPINGS,
  GET_PROGRAMS,
  GET_CORE_RATIO_BUCKETS,
  GET_BILLABILITY_TYPES,
  GET_CORE_RATIO_BASIS,
  GET_COUNTRIES,
  GET_JOB_CODE_MAPPINGS,
  CREATE_JOB_CODE_MAPPING,
  UPDATE_JOB_CODE_MAPPING,
  DELETE_JOB_CODE_MAPPING,
  BULK_UPDATE_JOB_CODE_MAPPINGS,
  GET_DEPARTMENTS,
  GET_JOB_CODES,
  OVERRIDE_GET_EMPLOYEEDATA,
  SAVE_EMPLOYEEDATA,
  SAVE_STATUSDISPOSITION_V2,
  BULK_GET_CLASSDATA,
  SAVE_CLASSDATA,
  GET_RITM_WITH_TASKS,
  GET_TASK_STATES,
  UPDATE_TASK,
  BULK_UPDATE_TASKS,
  ADD_COMMENT_TO_TASK,
  REFRESH_RITM_CACHE,
  SEARCH_ASKNOW_USERS,
  GET_DISTINCTTECHTYPES,
  GET_OVERTURERESULT,
  VALIDATE_NO_ROSTER_ID_EXCEL,
  GET_NO_ROSTER_ORACLE_ID_DETAILS,
  GET_ALL_NO_ROSTER_ID_CLASS,
  GET_OSR_APPROVING_AUTHORITY_EMAIL,
  CREATE_OVERNIGHT_SHIPPING_REQUEST,
} from "./CONSTANTS";

import axiosInstance, { getTokenClaims } from "./axiosInstance";

const BASE_URL = process.env.REACT_APP_BASE_URL_CONFIG;

export const checkPermission = async (access) => {
  if (access) {
    const allPermissions = [
      "General_Limited_Group",
      "PII_Group",
      "PII_Group_Low",
      "PII_Group_Med",
      "PII_Group_FULL",
      "Ops_Group",
      "OG_Group",
      "LD_Group",
      "LD_Group_Admin",
      "TA_Group",
      "WFM_Group",
      "CP_Group",
      "ISU_PRV_Access",
      "ASD_Group",
    ];
    return allPermissions.some((permission) => access.includes(permission));
  }
  return false;
};

export const getAttendanceNa = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ATTENDANCE_NA() + "?classRosterId=" + rosterId)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeDetails = (oracleId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + VIEW_TRAINEE_DETAILS(), { params: { oracleId } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const rosterHistory = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + ROSTER_HISTORY(), {
          params: { classRosterId: rosterId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFileAttachment = (type) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_FILE_ATTACHMENT(), { params: { type } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveFileAttachment = (
  classRequestId,
  classRosterId,
  fileAttachmentTypeId,
  modifiedBy,
  selectedFile,
  fileRawData,
) => {
  return new Promise((resolve, reject) => {
    try {
      const params = {
        classRequestId,
        ...(classRosterId !== null ? { classRosterId } : {}),
        fileAttachmentTypeId,
        modifiedBy,
      };

      const formData = new FormData();
      if (selectedFile !== null && selectedFile.length > 0) {
        for (const key of Object.keys(selectedFile)) {
          formData.append("file", selectedFile[key]);
        }
      }

      if (fileRawData !== null && fileRawData.length > 0) {
        formData.append(
          "fileData",
          JSON.stringify({ ProductionSchedule: fileRawData }),
        );
      }

      axiosInstance
        .post(BASE_URL + SAVE_FILE_ATTACHMENT(), formData, {
          params,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          resolve(error);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getWaveByClassRequestId = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_WAVE(), { params: { classRequestId: id } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchTrainee = (type, value) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + SEARCH_TRAINEE(), {
          params: { searchType: type, searchvalue: value },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchClassTraineeBySearchType = (searchType, searchValue) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + SEARCH_CLASS_TRAINEE_BY_SEARCH_TYPE(), {
          params: { searchType, searchvalue: searchValue },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveTtd = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_TTD(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveTciData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_TCI(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTciData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + OVERRIDE_GET_TCI(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveemployeeData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_EMPLOYEES(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const savemilestonesData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_MILESTONES(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOverrideEmployees = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + OVERRIDE_GET_EMPLOYEE(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOverrideMilestones = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + OVERRIDE_GET_MILESTONE(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveAccData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ACC(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAccData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_ACC_DATA(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateProductTraining = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_PRODUCT_TRAINING(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateTpc = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_TPC(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      resolve(error);
    }
  });
};

export const updateTtf = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_TTF(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateStatusOverride = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_STATUS_DISPOSITION(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateAttendance = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ATTENDANCE(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const geTtd = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + OVERRIDE_GET_TTD(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTpcData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_TPC(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProductTraining = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_PRODUCT_TRAINING(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTtfData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_TTF(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getStatusOverride = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_STATUS_DISPOSITION(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getBulkAttendance = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_ATTENDANCE(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeTicket = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_EMPLOYEE_TICKET(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateEmployeeTicket = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_EMPLOYEE_TICKET(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const postRescheduler = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + POST_RESCHEDULE() + "/", body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getreasonDetails = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_REASON_DETAILS(id), {
          params: { traineeStatusId: id },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getparentClientList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PARENT_CLIENT_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getUnassignedTrainee = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_UNASSIGNED_TRAINEE() + "/", body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterID = (rosterid, parentClientId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_ID(), {
          params: { classRosterId: rosterid, parentClientCode: parentClientId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TRAINEE_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteRoaster = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + DELETE_ROSTER(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSearchValue = (value) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_SEARCH_VALUE(), { params: { name: value } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDropdownList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_AGENT_TRACKER_SEARCH())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProjectDetails = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PROJECT_DETAILS(), {
          params: { parentClientCode: id },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRequest = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CLASS_REQUEST(), { params: { classRequestId: id } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getParentClientDetails = (data) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PARENT_CLIENT(), {
          params: {
            parentClientCode: data.parentClientCode,
            requestStatus: data.requestStatus || null,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchClassRequestDetailsByParentClient = (data) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + SEARCH_CLASS_REQUET_DETAILS(), {
          params: {
            parentClientCode: data.parentClientCode,
            requestStatus: data.requestStatus,
            pageNumber: data.pageNumber,
            pageSize: data.pageSize,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllRosterStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALL_ROSTER_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRosterWithStatus = (
  rosterStatusIds = [],
  last12MonthsOnly = false,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CLASS_ROSTER_WITH_STATUS(), {
          params: {
            // Comma-separated list, e.g. "1,4" - backend filters to only
            // rosters matching these RosterStatusIds instead of returning
            // the entire table.
            rosterStatusIds: rosterStatusIds.join(","),
            // When true, backend further restricts Closed/Cancelled rosters
            // to the last 12 months (by ModifiedDate). No effect on other statuses.
            last12MonthsOnly,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAsttHomeAssignedRosters = (oracleId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ASTT_HOME_ASSIGNED_ROSTERS(), {
          params: {
            oracleId,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchClassRosterDetails = (
  varClassRequestId,
  varClassRosterId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CLASS_ROSTER_DETAILS_WITH_REQUEST_ROSTER_ID(), {
          params: {
            classRequestId: varClassRequestId,
            classRosterId: varClassRosterId,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeDetailsByRoster = (varClassRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TRAINEE_DETAILS_BY_ROSTER_ID(), {
          params: { classRosterId: varClassRosterId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const reactivateClassTrainee = (varClassTraineeId, varModifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + REACTIVATE_CLASS_TRAINEE(),
          {},
          {
            params: {
              classTraineeId: varClassTraineeId,
              modifiedBy: varModifiedBy,
            },
          },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRequisitionList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_REQUISITION_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRequisitionDetails = (requisitionId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_REQUISITION_DETAILS(), {
          params: { requisitionId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterDetailsByRequisitionId = (requisitionId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_DETAILS_BY_REQUISITION_ID(), {
          params: { requisitionId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getParentClientWithClassRequestDetails = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PARENT_CLIENT_DETAILS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterDetails = (classRosterId, classRequestId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_DETAILS(), {
          params: {
            searchType: classRosterId || null,
            classRequestId: classRequestId || null,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Function to fetch all the users.
 */
export const getAllUsers = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_ALL_USERS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSiteLocatioins = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_SITE_LOC())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const postClassRequest = (id, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_CLASS_REQUEST() + "/", body, {
          params: { classRequestId: id },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateRosterConfiguration = (id, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_ROSTER_CONFIG() + "/", body, {
          params: { classRosterId: id },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createRosterConfig = (id, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_ROSTER(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createClassRequest = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_CLASS_REQUEST() + "/", body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getUserDetails = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_USER_DETAILS(id))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getParentClientSearch = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PARENT_CLIENT_SEARCH())
        .then((res) => {
          resolve(res.data.data.parentClientDetails);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterConfig = (id, data) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_CONFIG(), {
          params: { rosterId: id, isRosterClone: data },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterConfigByRosterId = (id, data) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_CONFIG_BY_ID(), {
          params: { classRosterId: id, isRosterClone: data },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmDetails = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_DETAILS() + "?classRosterId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertIdmTicket = (ticket, data, rosterId, validation) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + INSERT_IDM_TICKET(), data, {
          params: { IsIDMTicketValidate: validation },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertFacilityTicket = (data, validation) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + INSERT_FACILITIES_TICKET(), data, {
          params: { IsFacilitiesTicketValidate: validation },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteIdmAndFacTicket = (
  ticket,
  rosterId,
  facilitiesTicketNumber,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            DELETE_IDM_AND_FAC_TICKET() +
            "?classRosterId=" +
            rosterId +
            "&IDMTicketNumber=" +
            ticket +
            (facilitiesTicketNumber
              ? "&FacilitiesTicketNumber=" + facilitiesTicketNumber
              : ""),
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteFileAttachment = (fileDocLibID, deletedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            DELETE_FILE_ATTACHMENT() +
            "?fileDocLibId=" +
            fileDocLibID +
            "&deletedBy=" +
            deletedBy,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const techEquipSolution = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(`${BASE_URL}${TECH_EQUIPMENT_SOLUTION()}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const fingerPrinting = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(`${BASE_URL}${FINGER_PRINTING()}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const adjudication = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(`${BASE_URL}${ADJUDICATION()}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const language = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(`${BASE_URL}${LANGUAGE()}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getdistributionType = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + DISTRIBUTION_TYPE())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Get Trainees
export const getTrainees = (
  requistionId,
  oracleIds = [],
  classRosterId,
  classRequestId,
) => {
  return new Promise((resolve, reject) => {
    try {
      const data = {
        classRequestId: parseInt(classRequestId),
        classRosterId: parseInt(classRosterId),
        requistionId,
        oracleIds: oracleIds.length === 0 ? [] : oracleIds.split(","),
      };
      axiosInstance
        .post(BASE_URL + GET_UNASSIGNED_TRAINEE(), JSON.stringify(data))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// View Trainees
export const viewTrainees = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          `${BASE_URL}${VIEW_ASSIGNED_TRAINEE()}?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Status Disposition
export const getStatusDisposition = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_STATUSDISPOSITION(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const postStatusDisposition = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_SAVESTATUSDISPOSITION(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Employee Equipment
export const getEmployeeEquipment = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_EMPLOYEE_EQUIPMENT(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getInformaticaEmployeeData = (body, isPrvAccess) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            GET_INFORMATICA_EMPLOYEE_DATA() +
            `?isPrvAccess=${isPrvAccess}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeADStatusByOracleId = (oracleIds, classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          `${BASE_URL}${GET_EMPLOYEE_ADSTATUS_BY_ORACLEID()}?oracleIds=${oracleIds}&?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIDMTicketDetails = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          `${BASE_URL}${GET_IDM_TICKET_DETAILS()}?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRefreshedTrackingStatus = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + REFRESH_TRACKING_STATUS(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveEmployeeEquipment = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_SAVE_EMPLOYEE_EQUIPMENT(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Class
export const getClass = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_GET_CLASS(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveClass = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_POST_CLASS(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// save trainee in roster config
export const saveRosterTrainee = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_TRAINEE_ROSTER(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// get trainee in roster config
export const getRosterTrainee = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_TRAINEE_ROSTER() + "?classRosterId=" + classRosterId,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveRescheduleTransfer = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_RESCHEDULE_TRANSFER(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Service will return the JSON array of objects contains
// rosterDetail & traineeDetails details for Ask Now IDM ticket creation.
export const getIdmTraineesDetails = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_ROSTER_IDM_TRAINEES_DETAIL() + "?classRosterId=" + id,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getIdmTraineesDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeDetailsForIDMTicketByRosterId = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_TRAINEE_DETAILS_FOR_IDMTICKET_BY_ROSTERID() +
            "?classRosterId=" +
            rosterId,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getTraineeDetailsForIDMTicketByRosterId axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Lock Roster API
export const lockRosterConfig = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + ROSTER_LOCK(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAssociatedReqIds = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TALEO_REQ_IDS() + "?rosterId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getSiteLocation axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSiteLocation = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_SITE_LOCATION() + "?classRequestId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getSiteLocation axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_EMPLOYEE_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getEmployeeList axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIDMUserDetails = (userId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_USER_DETAILBYID() + "?UserID=" + userId)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getIDMUserDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFileAttachmentDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + FILE_ATTACHMENT_DETAILS(), {
          params: { id, fileAttachmentCategory: data },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTechDepType = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_TECH_DEP_TYPE_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getTechDepType axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createIdmOrderRequest = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + IDM_CREATE_ORDER_REQUEST(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmRitmDetail = (reqSysId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_RITM_DETAIL() + "?sysId=" + reqSysId)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getIdmRitmDetail axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const SaveAttachmentRitm = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ATTACHMENT_RITM(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const SaveAttachmentFacilities = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ATTACHMENT_FACILITIES(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const SaveAttachmentRitmForClient = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ATTACHMENT_RITM_CLIENT(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const SaveAttachmentRitmForCapClient = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ATTACHMENT_RITM_CAPCLIENT(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClientProgram = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_CLIENT_PROGRAM())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getClientProgram axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRosterIds = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ROSTER_ID_LIST())
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Special case: uses getTokenClaims() to replace the manual atob token decode.
export const getPiiData = async (id, piiAccess) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PII_DATA(), {
          params: {
            classRosterId: id,
            PIIAccess: piiAccess,
            LoginUserEmail: localStorage.getItem("EmailId"),
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getPiiData axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getPiiDatabyOracleId = (oracleId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PII_DATA_BY_ORACLEID() + `?oracleId=${oracleId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getPiiDatabyOracleId axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const SaveRitmComment = (ritmSysId, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_RITM_COMMENT() + "?sysId=" + ritmSysId, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOracleIdsPII = (ticketNumber) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ORACLEIDSPII(), {
          params: { idmTicketNumber: ticketNumber },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOracleidsPIIByFacilitiesTicketNumber = (ticketNumber) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ORACLEIDSPIIBY_FACILITIESTICKETNUMBER(), {
          params: { facilitiesTicketNumber: ticketNumber },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOracleIds = (ticketNumber) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ORACLEIDS(), {
          params: { idmTicketNumber: ticketNumber },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOBTManagementInfo = (parentClientDsc) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_OBT_MANAGEMENT_INFO(), {
          params: { parentClientDesc: parentClientDsc },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOBTManagementInfoById = (selectedIds) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_OBT_MANAGEMENT_INFO_BY_ID() +
            `/?obtInfoId=${selectedIds}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getInfoClientDetails = (classRequestId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_INFORMATIC_CLIENT() +
            `/?classRequestId=${classRequestId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOBTInfo = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_OBT_INFO(), body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCurrentEquipmentSetup = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CURRENT_EQUIPMENT_SETUP())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllClassRequestIds = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALL_CLASSREQIDs())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterTraineesByClassReqId = (classRequestId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_ROSTER_TRAINEES_BY_CLASSREQIDs() +
            `/?classRequestId=${classRequestId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterConfigDetailsForAssignTrainee = (classRequestId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_ROSTERCONFIGDETAILS_FOR_ASSIGNTRAINEE() +
            `/?classRequestId=${classRequestId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveAssignRosters = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ASSIGN_TRAINEES(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAgentCommentsByRosterId = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_AGENT_COMMENTS_BYROSTERID() +
            `/?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getnewClientProgram = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_NEW_CLIENT_PROGRAM() + "?classRequestId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getnewClientProgram axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateRosterRequisitionMap = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_ROSTERREQUISITION(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const RemoveRosterRequisitionMap = (requestBody) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + REMOVE_ROSTER_REQUISITION_MAP(), requestBody)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRosterMilestoneSearchResults = (
  classRequestId,
  classRosterId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_ROSTERMILESTONE_SEARCHRESULTS() +
            `/?classRequestId=${classRequestId}&classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getRosterMileStoneSearchResults axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeMilestoneAssociate = (classRosterId, milestoneId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_TRAINEEMILESTONE_ASSOCIATE() +
            `?classRosterId=${classRosterId}&milestoneId=${milestoneId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getTraineeMilestoneAssociate axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteMilestoneAssociate = (classRosterId, milestoneId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(BASE_URL + DELETE_MILESTONE_ASSOCIATE(), {
          params: {
            classRosterId,
            milestoneId,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in deleteMilestoneAssociate axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllMilestones = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALL_MILESTONES())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getAllMilestones axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveClassRosterMilestones = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_CLASSROSTERMILESTONES(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveMileStoneEdit = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_MILESTONEEDIT(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const CreateMilestone = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_MILESTONE(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllMilestonesWithStatuses = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_ALL_MILESTONES_WITH_STATUSES() +
            `/?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updatesMilestonesReorder = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_MILESTONEREORDER(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveMileStoneStatusEdit = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_MILESTONESTATUSEDIT(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const CreateMilestoneStatus = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_MILESTONESTATUS(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getBulkMilestoneCount = (milestoneId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_BULK_MILESTONE_COUNT() + `?milestoneId=${milestoneId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertBulkMilestone = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + INSERT_BULK_MILESTONE(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMilestoneDataType = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_MILESTONE_DATATYPE())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getMilestoneDataType!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMilestoneWithListType = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_MILESTONE_WITH_LIST_TYPE())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getMilestoneWithListType!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOBTEmailDetails = (
  OBTManagementInfoId,
  ClientDistro,
  ClientOffboarding,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(
          BASE_URL +
            SAVE_OBT_EMAIL_DETAILS() +
            `?OBTManagementInfoId=${OBTManagementInfoId}&ClientDistro=${ClientDistro}&ClientOffboarding=${ClientOffboarding}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in SaveOBTEmailDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAskNowBSTaskDetails = (fullProjectCode) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_ASKNOW_BS_TASK_DETAILS() +
            `?fullProjectCode=${fullProjectCode}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveAskNowBSTaskDetails = (sysId, jsonPayload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + SAVE_ASKNOW_BS_TASK_DETAILS() + `?sysId=${sysId}`,
          jsonPayload,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeITAMStatusByRosterId = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_TRAINEE_ITAM_STATUS_BY_ROSTERID() +
            `/?classRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const refreshITAMStatus = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + REFRESH_ITAMSTATUS(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchEmployeeProfile = (searchCriteria) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            SEARCH_EMPLOYEE_PROFILE() +
            `?searchCriteria=${searchCriteria}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchClassTraineeProfile = (searchCriteria, traineeStatusId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + SEARCH_CLASS_TRAINEE_PROFILE(), {
          params: { searchCriteria, traineeStatusId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveRosterConfigDetails = (
  classRosterId,
  classRequestId,
  isRosterClone,
  applyUpdateToAll,
  requestedBy,
  jsonPayload,
) => {
  return new Promise((resolve, reject) => {
    try {
      const url =
        BASE_URL +
        SAVE_ROSTER_CONFIG_DETAILS() +
        `?classRosterId=${classRosterId}&classRequestId=${classRequestId}&` +
        `isRosterClone=${isRosterClone}&applyUpdateToAll=${applyUpdateToAll}&requestedBy=${requestedBy}`;

      axiosInstance
        .post(url, jsonPayload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const uploadAgentScheduleForRoster = (classRosterId, classRequestId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            UPLOAD_AGENT_SCHEDULE_DOC_LIB() +
            `/?classRosterId=${classRosterId}&classRequestId=${classRequestId}`,
          {},
        )
        .then((res) => {
          const { statusCode, message, data } = res.data;
          resolve({ statusCode, message, data });
        })
        .catch((err) => {
          if (err.response) {
            const { statusCode, message } = err.response.data;
            reject({ statusCode, message });
          } else {
            reject({
              statusCode: 500,
              message: "Unexpected error occurred while making the API call.",
            });
          }
        });
    } catch (error) {
      reject({
        statusCode: 500,
        message: "Unexpected error occurred in the function.",
      });
    }
  });
};

export const getTraineeProductionSchedule = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TRAINEE_PRODUCTION_SCHEDULE(), {
          params: { classRosterId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getConfirmAgentScheduleByRoster = (
  classRosterId,
  classRequestId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CONFIRM_AGENT_SCHEDULE_BY_ROSTER() +
            `?classRosterId=${classRosterId}&classRequestId=${classRequestId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmRosterList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDMROSTER_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmRosterDetail = (rosterid) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDMROSTER_DETAILS(), {
          params: { classRosterId: rosterid },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmCredentialRosterDetailsByTrackingId = (idmTrackingId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          `${BASE_URL}${GET_IDMCREDENTIAL_ROSTER_DETAILS_BY_TRACKINGID()}?trackingId=${idmTrackingId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmCredentialByTrackingId = (idmTrackingId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          `${BASE_URL}${GET_IDMCREDENTIAL_BY_TRACKINGID()}?trackingId=${idmTrackingId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmSystemImpacted = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDMSYSTEM_IMPACTED())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmSwitchType = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDMSWITCH_TYPE())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmSanityCheckNotes = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_SANITY_CHECKNOTES())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmIssueDescription = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_IDM_ISSUE_DESCRIPTION())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertIdmCredential = (payload, isNoClassRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            CREATE_IDMCREDENTIALTRACKING() +
            `?isNoClassRosterId=${isNoClassRosterId}`,
          payload,
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateIdmCredential = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_IDMCREDENTIALTRACKING(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteIdmCredential = (idmCredentialTrackingId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            DELETE_IDMCREDENTIALTRACKING() +
            `?idmCredentialTrackingId=${idmCredentialTrackingId}`,
          {},
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getIdmCredentialsByProductTrainingMonth = (month, year) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_IDM_CREDENTIALS_BY_PRODUCTTRAINING_MONTH() +
            `?month=${month}&year=${year}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const IdmCredentialLock = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + IDMCREDENTIALTRACKING_LOCK(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createAccessRequest = (oracleId, description) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            ACCESS_REQUEST() +
            "?oracleId=" +
            oracleId +
            "&description=" +
            description,
          {},
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getConfigurationValues = (configName) => {
  return new Promise((resolve) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CONFIGURATION_VALUES() +
            `?ConfigurationKey=${configName}`,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          resolve({ error: true });
        });
    } catch (error) {
      resolve({ error: true });
    }
  });
};

export const getReleaseUpdates = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_RELEASEUPDATES())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createReleaseUpdate = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_RELEASEUPDATE(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateReleaseUpdate = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_RELEASEUPDATE(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteReleaseUpdate = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + DELETE_RELEASEUPDATE(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertIdmEmailQueue = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_IDMEMAILQUEQE(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllClients = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALLCLIENTS())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getAllClients axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProjectsByClientCode = (clientCode) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_PROJECTS_BY_CLIENTCODE() + `?clientCode=${clientCode}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOBTInfoManagementByProjectCode = (projectCodes) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_OBTMANAGEMENTINFO_BY_PROJECTCODE() +
            `?projectCodes=${projectCodes}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertFacilitiesTicket = (
  oracleId,
  locationName,
  locationId,
  description,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            CREATE_FACILITIES_REQUEST() +
            "?oracleId=" +
            oracleId +
            "&locationName=" +
            locationName +
            "&locationId=" +
            locationId +
            "&description=" +
            description,
          {},
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ─── PUBLIC ENDPOINTS — intentionally use raw axios (no auth header) ──────────

export const noAuthAccessRequest = (oracleId, description) => {
  return new Promise((resolve, reject) => {
    try {
      const apiUrl =
        BASE_URL +
        NOAUTH_ACCESS_REQUEST() +
        "?oracleId=" +
        oracleId +
        "&description=" +
        description;
      const response = axios.post(apiUrl, {
        headers: { "Content-Type": "application/json" },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRitmDetail = (reqSysId) => {
  return new Promise((resolve, reject) => {
    try {
      const apiUrl = BASE_URL + GET_RITM_DETAILS() + "?sysId=" + reqSysId;
      const response = axios.get(apiUrl, {
        headers: { "Content-Type": "application/json" },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ─────────────────────────────────────────────────────────────────────────────

export const getAiPrompt = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_AIPROMPT_RESPONSE(), payload)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllParentClients = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_PARENTCLIENTS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllProjectsByParentClientCode = (parentClientCode) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_PROJECTS_BY_PARENTCLIENTCODE(),
        { params: { parentClientCode } },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getWaveDetails = (projectCode) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_WAVE_BY_PROJECTCODE(), {
        params: { projectCode },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRosters = (projectCode, wave) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_CLASSROSTERS(), {
        params: { projectCode, wave },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassSearchResults = (
  projectCode,
  wave,
  classRosterId,
  className = null,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_CLASS_SEARCHRESULTS(), {
        params: {
          projectCode,
          wave,
          classRosterId,
          ...(className ? { className } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllNoRosterIdClasses = (asdLead, oracleId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_NO_ROSTER_ID_CLASS(),
        {
          params: {
            ...(asdLead ? { asdLead } : {}),
            ...(oracleId ? { oracleId } : {}),
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllTechSolutions = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_TECHSOLUTIONS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getBulkReBuild = (techSolutionId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_BULK_REBUILD_BY_TECHSOLUTIONID(),
        { params: { techSolutionId } },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllTaskTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_TASKTYPES());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_STATUS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTClassDetailsHistory = (omtClassDetailsId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_OMT_CLASSDETAILS_HISTORY(),
        {
          params: { omtClassDetailsId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTClassDetails = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_OMT_CLASSDETAILS(), body)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const cancelOMTSchedule = (requestBody, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(BASE_URL + DELETE_OMT_CLASSSCHEDULE(), {
          params: { modifiedBy },
          data: requestBody,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err?.response?.data || err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const reschedulecancelledOMTSchedule = (requestBody, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(BASE_URL + RESCHEDULE_DELETED_OMT_CLASSSCHEDULE(), {
          params: { modifiedBy },
          data: requestBody,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err?.response?.data || err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateDataNitivClassId = (classRosterId, dataNitivClassId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            UPDATE_DATANITIV_CLASS_LIB() +
            `/?classRosterId=${classRosterId}&dataNitivClassId=${dataNitivClassId}`,
          {},
        )
        .then((res) => {
          const { statusCode, message, data } = res.data;
          resolve({ statusCode, message, data });
        })
        .catch((err) => {
          if (err.response) {
            const { statusCode, message } = err.response.data;
            reject({ statusCode, message });
          } else {
            reject({
              statusCode: 500,
              message: "Unexpected error occurred while making the API call.",
            });
          }
        });
    } catch (error) {
      reject({
        statusCode: 500,
        message: "Unexpected error occurred in the function.",
      });
    }
  });
};

export const getClassRosterForAsdLead = (
  projectCode,
  wave,
  asdLeadOracleId,
  agentOracleId,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_CLASSROSTERS_FORASDLEAD(),
        {
          params: {
            projectCode,
            wave,
            asdLeadOracleId,
            oracleId: agentOracleId,
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRostersTaskType = (classRosterId, noRosterIdClassName) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_CLASSROSTERS_TASKTYPE(),
        {
          params: {
            ...(classRosterId ? { classRosterId } : {}),
            ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRostersScheduleType = (
  classRosterId,
  omtTaskTypeId,
  noRosterIdClassName,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_CLASSROSTERS_SCHEDULETYPE(),
        {
          params: {
            ...(classRosterId ? { classRosterId } : {}),
            ...(omtTaskTypeId ? { taskTypeId: omtTaskTypeId } : {}),
            ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTAttendance = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_ATTENDANCE(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTAttendance = (body, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + BULK_POST_OMT_ATTENDANCE() + `?modifiedBy=${modifiedBy}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllOMTHardwareStatuses = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_OMT_HARDWARE_STATUSES(),
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTHardware = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_HARDWARE(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveHardware = (payload, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + `${SAVE_OMT_HARDWARE()}?modifiedBy=${modifiedBy}`,
          payload,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTCredentials = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_CREDENTIALS(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTCredentials = (body, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + BULK_POST_OMT_CREDENTIALS() + `?modifiedBy=${modifiedBy}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTNetwork = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_NETWORK(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTNetwork = (body, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + BULK_POST_OMT_NETWORK() + `?modifiedBy=${modifiedBy}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTOperatingSystem = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_OPERATINGSYSTEM(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTOperatingSystem = (body, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            BULK_POST_OMT_OPERATINGSYSTEM() +
            `?modifiedBy=${modifiedBy}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTAttachments = (
  omtClassDetailsId,
  omtScheduleStatusType,
  category,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_ATTACHMENT(), {
        params: { omtClassDetailsId, omtScheduleStatusType, category },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTClassDetailsFlags = (omtClassDetailsId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_OMT_CLASSDETAILSFLAGS(),
        {
          params: { omtClassDetailsId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTAttachments = (
  files,
  category,
  classRosterId,
  oracleId,
  omtClassDetailsId,
  omtScheduleStatusType,
  attachmentId,
  comments,
  noRosterIdClassName = null,
) => {
  const formData = new FormData();
  for (let file of files) {
    formData.append("Files", file);
  }
  formData.append("Category", category);
  formData.append("ClassRosterId", classRosterId ?? "");
  formData.append("NoRosterIdClassName", noRosterIdClassName ?? "");
  formData.append("OracleId", oracleId);
  formData.append("OMTClassDetailsId", omtClassDetailsId);
  formData.append("OMTScheduleStatusType", omtScheduleStatusType);
  formData.append("AttachmentId", attachmentId);
  formData.append("Comments", comments);
  formData.append("ModifiedBy", localStorage.getItem("User")); // display value — intentionally kept

  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_OMT_ATTACHMENT(), formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err?.response?.data || err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOMTApplication = (
  rosterId,
  asdLeadOracleId,
  taskTypeId,
  scheduleType,
  agentOracleId,
  noRosterIdClassName,
  isNoRosterIdSearch,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_OMT_APPLICATION(), {
        params: {
          classRosterId: rosterId,
          asdLeadOracleId,
          taskTypeId,
          scheduleType,
          oracleId: agentOracleId,
          ...(noRosterIdClassName ? { noRosterIdClassName } : {}),
          ...(isNoRosterIdSearch ? { isNoRosterIdSearch } : {}),
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveOMTApplication = (body, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL + BULK_POST_OMT_APPLICATION() + `?modifiedBy=${modifiedBy}`,
          body,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteOMTAttachmentByFileDocLibId = (fileDocLibId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.delete(
        BASE_URL + DELETE_OMT_ATTACHMENT() + `/${fileDocLibId}`,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const jiraFeatureRequest = (
  summaryTitle,
  description,
  acceptanceCriteria,
  loggedOnMailId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            JIRA_FEATURE_REQUEST() +
            "?summaryTitle=" +
            summaryTitle +
            "&description=" +
            description +
            "&acceptanceCriteria=" +
            acceptanceCriteria +
            "&loggedOnMailId=" +
            loggedOnMailId,
          {},
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCoreRatioMapping = (
  programCode = null,
  countryCode = null,
  coreRatioBucketId = 0,
  includeInactive = false,
  asOfDate = null,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_CORE_RATIO_MAPPING(), {
        params: {
          programCode,
          countryCode,
          coreRatioBucketId,
          includeInactive,
          asOfDate,
        },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createCoreRatioMapping = (mappingData) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        `${BASE_URL}/${CREATE_CORE_RATIO_MAPPING()}`,
        mappingData,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateCoreRatioMapping = (mappingData) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.put(
        `${BASE_URL}/${UPDATE_CORE_RATIO_MAPPING()}`,
        mappingData,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const bulkUpdateCoreRatioMappings = (bulkUpdateData) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.put(
        `${BASE_URL}/${BULK_UPDATE_CORE_RATIO_MAPPINGS()}`,
        bulkUpdateData,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getPrograms = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(`${BASE_URL}/${GET_PROGRAMS()}`, {
        params: { includeInactive },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCoreRatioBuckets = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        `${BASE_URL}/${GET_CORE_RATIO_BUCKETS()}`,
        {
          params: { includeInactive },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getBillabilityTypes = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        `${BASE_URL}/${GET_BILLABILITY_TYPES()}`,
        {
          params: { includeInactive },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCoreRatioBasis = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        `${BASE_URL}/${GET_CORE_RATIO_BASIS()}`,
        {
          params: { includeInactive },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteCoreRatioMapping = (deleteData) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.delete(
        `${BASE_URL}/${DELETE_CORE_RATIO_MAPPING()}`,
        {
          data: deleteData,
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCountries = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(`${BASE_URL}/${GET_COUNTRIES()}`, {
        params: { includeInactive },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getJobCodeMappings = (
  programCode = null,
  countryCode = null,
  jobCode = null,
  departmentCode = null,
  coreRatioBucketId = 0,
  includeInactive = false,
  asOfDate = null,
) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        `${BASE_URL}/${GET_JOB_CODE_MAPPINGS()}`,
        {
          params: {
            programCode,
            countryCode,
            jobCode,
            departmentCode,
            coreRatioBucketId,
            includeInactive,
            asOfDate,
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createJobCodeMapping = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        `${BASE_URL}/${CREATE_JOB_CODE_MAPPING()}`,
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateJobCodeMapping = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.put(
        `${BASE_URL}/${UPDATE_JOB_CODE_MAPPING()}`,
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteJobCodeMapping = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.delete(
        `${BASE_URL}/${DELETE_JOB_CODE_MAPPING()}`,
        {
          data: payload,
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const bulkUpdateJobCodeMappings = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.put(
        `${BASE_URL}/${BULK_UPDATE_JOB_CODE_MAPPINGS()}`,
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDepartments = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(`${BASE_URL}/${GET_DEPARTMENTS()}`, {
        params: { includeInactive },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getJobCodes = (includeInactive = false) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(`${BASE_URL}/${GET_JOB_CODES()}`, {
        params: { includeInactive },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOverrideEmployeesData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + OVERRIDE_GET_EMPLOYEEDATA(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveBulkEditEmployeeData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_EMPLOYEEDATA(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const postStatusDispositionV2 = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_STATUSDISPOSITION_V2(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getRitmWithTasks = (ritmNumber) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_RITM_WITH_TASKS() + `/${ritmNumber}`, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTaskStates = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TASK_STATES(), { validateStatus: false })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateTask = (taskSysId, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .patch(BASE_URL + UPDATE_TASK() + `/${taskSysId}`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const bulkUpdateTasks = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .patch(BASE_URL + BULK_UPDATE_TASKS(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const addCommentToTask = (taskSysId, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + ADD_COMMENT_TO_TASK() + `/${taskSysId}/comment`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const refreshRitmCache = (ritmNumber) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + REFRESH_RITM_CACHE() + `/${ritmNumber}/refresh`, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchUsers = (query) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + SEARCH_ASKNOW_USERS(), { params: { query } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + BULK_GET_CLASSDATA(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveBulkEditClassData = (body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_CLASSDATA(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDistinctTechTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_DISTINCTTECHTYPES());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOvertureData = (classRosterId, oracleId, techType) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_OVERTURERESULT() +
            `/?classRosterId=${classRosterId}&oracleId=${oracleId}&techType=${techType}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            resolve([]);
          } else {
            reject("Error in getOvertureData axios!");
          }
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const validateNoRosterIdExcel = (oracleIds) => {
  return new Promise((resolve, reject) => {
    try {
      const payload = {
        oracleIds: oracleIds.map((oracleId, index) => ({
          id: index + 1,
          oracleId: oracleId,
        })),
      };
      axiosInstance
        .post(BASE_URL + VALIDATE_NO_ROSTER_ID_EXCEL(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err?.response?.data || SYSTEM_ERROR);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getNoRosterOracleIdDetails = (oracleIds) => {
  return new Promise((resolve, reject) => {
    try {
      const payload = {
        oracleIds: oracleIds.map((oracleId, index) => ({
          id: index + 1,
          oracleId: oracleId,
        })),
      };
      axiosInstance
        .post(BASE_URL + GET_NO_ROSTER_ORACLE_ID_DETAILS(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err?.response?.data || SYSTEM_ERROR);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getOSRApprovingAuthorityEmailIds = (
  parentClientCode,
  department,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_OSR_APPROVING_AUTHORITY_EMAIL(), {
          params: { parentClientCode, department },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
export const submitOvernightShippingRequest = (id, parentClientId, body) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_OVERNIGHT_SHIPPING_REQUEST() + "/", body, {
          params: { classRequestId: id, parentClientCode: parentClientId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
export const saveRosterManagementFields = (jsonPayload) => {
  return new Promise((resolve, reject) => {
    try {
      const url = BASE_URL + SAVE_ROSTER_MANAGEMENT_FIELDS();

      axiosInstance
        .post(url, jsonPayload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
